
import { Vue, Component, Prop, Emit } from 'vue-property-decorator';
import VoteButton from '@/components/next/VoteButton.vue';

const defaultVoteItem = {
  cover:
    'https://image2.cqcb.com/d/file/headline/2019-08-07/43d7b72db2a857a9fd78d44af51b6c9a.png',
  title:
    '主标题要长主标题要长主标题要长主标题要长主标题要长主标题要长主标题要长主标题要长',
  subtitle:
    '测试子标题单行溢出隐藏测试子标题单行溢出隐藏测试子标题单行溢出隐藏',
  votes: 124,
  id: 2,
};

@Component({
  components: {
    VoteButton,
  },
})
export default class SyVoteItem extends Vue {
  @Prop({
    default: () => {
      return defaultVoteItem;
    },
  })
  voteItem!: any;
  show: boolean = false;
  @Prop({ default: false }) mustApp!: boolean;
  @Prop() voteName!: string;
  @Prop({ default: true }) voteWeChat!: boolean;
  @Prop() rankIndex!: number;

  @Emit()
  navTo() {
    return console.log('emit from vote item');
  }
  mounted() {
    this.gif();
  }
  gif() {
    this.voteItem.pictures[0].indexOf('.gif') === -1
      ? (this.show = true)
      : (this.show = false);
  }
}
